module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0038.jpg?v=cb362d0d";